import React from 'react';
import { twMerge } from 'tailwind-merge';

import './range-slider.css';

export type RangeSliderProps = {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step?: number;
  className?: string;
};

export function RangeSlider(props: RangeSliderProps) {
  const { value, onChange, min, max, step = 1, className } = props;

  // Sanitize all numbers to prevent NaN
  const safeValue = Number.isFinite(value) ? value : 0;
  const safeMin = Number.isFinite(min) ? min : 0;
  const safeMax = Number.isFinite(max) ? max : 100;

  // Calculate the percentage for the gradient fill
  const percentage =
    safeMax > safeMin
      ? Math.max(0, Math.min(100, ((safeValue - safeMin) / (safeMax - safeMin)) * 100))
      : 0;

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onChange(Number(e.target.value));
  }

  return (
    <div className={twMerge('w-full', className)}>
      <input
        type="range"
        min={safeMin}
        max={safeMax}
        step={step}
        value={safeValue}
        onChange={handleChange}
        className="range-slider w-full"
        style={
          {
            '--range-progress': `${percentage}%`,
          } as React.CSSProperties
        }
      />
    </div>
  );
}
